import { Control, FieldErrors, Path } from "react-hook-form";
import { FormFieldError, FormFieldLayout } from "./FormFieldLayouts";
import styles from "./formfields.module.css";
import { CSSProperties } from "react";
import { StringIndexedDict } from "../../api/GenericTypes";
import { GenericControllerProvider, GenericControllerProviderProps } from "../forms/common/GenericControllerProvider";
import { getError } from "./GenericVirtualizedSelectFormField/GenericVirtualizedEntitySelectFormFieldControllerWrapper";

export interface TextareaFormFieldControlledProps<Entity extends StringIndexedDict> {
  id: Path<Entity>;
  label: string;
  errors?: FieldErrors<Entity>;
  control: Control<Entity, any, Entity>;
  required?: boolean;
  autoFocus?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  defaultValue?: string | number;
  horizontal?: boolean;
  uncontained?: boolean;
  style?: CSSProperties;
  buttons?: React.ReactNode;
  wrapperContainerstyle?: CSSProperties;
  rows?: number;
  controllerFieldOverride?: GenericControllerProviderProps<Entity>["controllerFieldOverride"];
}

export const TextareaFormFieldControlled = <Entity extends StringIndexedDict>({
  id,
  label,
  errors,
  control,
  required,
  autoFocus,
  readOnly,
  placeholder = "Insert text...",
  defaultValue,
  horizontal = true,
  uncontained = false,
  style,
  buttons,
  wrapperContainerstyle,
  rows = 4,
  controllerFieldOverride,
}: TextareaFormFieldControlledProps<Entity>) => {
  const error = errors ? getError<Entity>(id, errors) : undefined;

  return (
    <GenericControllerProvider<Entity>
      id={id}
      control={control}
      defaultValue={defaultValue}
      controllerFieldOverride={controllerFieldOverride}
    >
      {({ value, onChange, onBlur }, fieldState, { errors }) => {
        return (
          <>
            {uncontained ? (
              <div className={`flex`} style={{ width: "100%", height: "100%", ...wrapperContainerstyle }}>
                <textarea
                  className={`${error ? "border-danger form-control" : "form-control"} ${required ? "required" : ""}`}
                  value={value}
                  onChange={(e) => onChange(e.target.value)}
                  onBlur={onBlur}
                  required={required}
                  autoFocus={autoFocus}
                  readOnly={readOnly}
                  placeholder={placeholder}
                  // defaultValue={defaultValue}
                  style={{ ...(readOnly && { cursor: "not-allowed" }), minHeight: "100%", resize: "none", ...style }}
                  autoComplete="off"
                  rows={rows}
                />
                {buttons ? <div className={styles.buttons}>{buttons}</div> : null}
                <FormFieldError id={id} errors={errors} />
              </div>
            ) : (
              <FormFieldLayout id={id} label={label} required={required} horizontal={horizontal}>
                <div className={styles.container} style={wrapperContainerstyle}>
                  <textarea
                    className={`${error ? "border-danger form-control" : "form-control"}`}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={onBlur}
                    required={required}
                    autoFocus={autoFocus}
                    readOnly={readOnly}
                    placeholder={placeholder}
                    // defaultValue={defaultValue}
                    style={{ ...(readOnly && { cursor: "not-allowed" }), resize: "none", ...style }}
                    rows={rows}
                  />
                  {buttons ? <div className={styles.buttons}>{buttons}</div> : null}
                </div>

                <FormFieldError id={id} errors={errors} />
              </FormFieldLayout>
            )}
          </>
        );
      }}
    </GenericControllerProvider>
  );
};
